// You can find the id here
// https://portal.sourcepoint.com/consent_v2/vendor_lists/edit?id=6233296a293cdf6b366969ee&non_iab=false
// Vendor: Criteo SA
const CRITEO_SA_ID: string = '5e98e7f1b8e05c111d01b462';
export default (grants: TSourcePointGrants): boolean => {
  return grants[CRITEO_SA_ID]?.vendorGrant;
};
